import './StatusSpokeForm.scss'

import { AGENT_STATUS_SPOKE } from 'common/constants'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { NoteField } from 'manager/views/components/ReferralStatus/NoteField'
import { saveStatus } from 'manager/redux/referral_status'
import { selectHasTourInfoOrValidNote, selectNote } from 'manager/selectors/referral_status_selectors'
import { selectIsPropertyInquiryTourUpdateNeeded } from 'manager/selectors/referral_selectors'
import { selectAgentVideoCallEnabled } from 'manager/selectors/auth'
import { selectManagerOpenUrlFeatureEnabled } from 'manager/selectors/manager_selectors'
import { StatusSubmitButton } from 'manager/views/components/ReferralStatus/StatusSubmitButton'
import { withRouter } from 'react-router'
import { goToLink } from 'common/util/helper'

import React from 'react'
import PropertyTourQuestions from 'manager/views/components/ReferralStatus/PropertyTourQuestions'

const SpokeForm = ({ hasTourInfoOrValidNote, isTourUpdateNeeded, note, isAgentVideoCallEnabled, saveStatus, openUrlFeatureEnabled }) => {
  const onSubmit = () => {
    saveStatus({
      action: 'update',
      status: AGENT_STATUS_SPOKE,
      payload: { note },
    })
  }

  const learnMore = () => {
    goToLink(openUrlFeatureEnabled, 'https://hub.realtor.com/social-distancing/video-tools-social-distancing')
  }

  return (
    <div className="StatusSpokeForm">
      <div className="ReferralStatusForm__body">
        { isTourUpdateNeeded && <PropertyTourQuestions /> }
        <NoteField />
      </div>
      <div className="ReferralStatusForm__footer">
        <StatusSubmitButton
          disabled={!hasTourInfoOrValidNote}
          onClick={onSubmit}>
          Update status
        </StatusSubmitButton>
      </div>
    </div>
  )
}

const selector = createStructuredSelector({
  hasTourInfoOrValidNote: selectHasTourInfoOrValidNote,
  isTourUpdateNeeded: selectIsPropertyInquiryTourUpdateNeeded,
  note: selectNote,
  isAgentVideoCallEnabled: selectAgentVideoCallEnabled,
  openUrlFeatureEnabled: selectManagerOpenUrlFeatureEnabled,
})

const actions = {
  saveStatus,
}

const withRedux = connect(selector, actions)

export const StatusSpokeForm = withRedux(withRouter(SpokeForm))
